import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { topics } from "@/mocks/topics";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100 mt-20">
      <div className="mx-auto max-w-content px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-secondary-950 flex items-center justify-center font-heading font-bold text-lg">
                黑
              </span>
              <span className="font-heading font-bold text-lg text-background-50">黑人</span>
            </div>
            <p className="text-sm leading-relaxed text-background-300">
              以内容权威性与文化深度为核心，聚焦黑人历史、音乐、影视、艺术与社会动态，提供系统化、多领域的深度资讯。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">分类浏览</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">文化专题</h4>
            <ul className="space-y-2.5">
              {topics.map((topic) => (
                <li key={topic.id}>
                  <Link
                    to={`/topic/${topic.id}`}
                    className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer"
                  >
                    {topic.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">关于与联系</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer">
                  站内搜索
                </Link>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-300">
                <i className="ri-mail-line text-accent-400" />
                contact@heiren-culture.example
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-background-200 hover:bg-accent-500 hover:text-secondary-950 transition-colors cursor-pointer">
                <i className="ri-wechat-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-background-200 hover:bg-accent-500 hover:text-secondary-950 transition-colors cursor-pointer">
                <i className="ri-weibo-line" />
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-background-200 hover:bg-accent-500 hover:text-secondary-950 transition-colors cursor-pointer">
                <i className="ri-mail-send-line" />
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-700">
        <div className="mx-auto max-w-content px-4 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © 2026 黑人 · 综合文化资讯平台 · 本站内容为演示示例数据
          </p>
          <p className="text-xs text-background-400">
            权威资讯 · 深度解读 · 多维发现
          </p>
        </div>
      </div>
    </footer>
  );
}